export default __webpack_public_path__ + "static/media/moonrise.96e90629.png";